import { HydrateOption } from '@core/enums';
import { Grid } from '@helpers/grid';
import withWidget from '@hoc/withWidget';
import Paragraph from '@stories/Components/Global/Typography/Paragraph';
import Image from '@stories/Components/Media/Image/Image';
import React from 'react';
import { PromoIconsStyles as S } from './PromoIcons.styles';
const PromoIcons = (props) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Inner, null,
            React.createElement(Grid.Default, null,
                React.createElement(S.Content, null,
                    React.createElement(S.Title, { semantic: "h2", visual: "h5" }, props.title),
                    React.createElement(Paragraph, { size: "regular", align: "center" }, props.copy)),
                props.icons && (React.createElement(S.Icons, null,
                    React.createElement(Grid.Inner, null, props.icons.map((x) => (React.createElement(S.IconCard, { key: x.title },
                        React.createElement(S.IconImage, null,
                            React.createElement(Image, { src: x.imageUrl || '', alt: x.title || '', width: 109, height: 81, objectFit: "contain", layout: "intrinsic" })),
                        React.createElement(S.IconTitle, null, x.title)))))))))));
};
export default withWidget(PromoIcons, 'PromoIcons', { hydrate: HydrateOption.InView });
